import { render } from "./SubscriberList.vue?vue&type=template&id=88ca3d88&scoped=true"
import script from "./SubscriberList.vue?vue&type=script&lang=js"
export * from "./SubscriberList.vue?vue&type=script&lang=js"

import "./SubscriberList.vue?vue&type=style&index=0&id=88ca3d88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ca3d88"]])

export default __exports__